// removed by extract-text-webpack-plugin
module.exports = {"homeMobile":"YkU1SzXO3ph5g49rJnO1n","stickyHeader":"_1EDdKD23iPc9kOLqkqx1Ji","stickyHeaderTitle":"_2b-sN1Cx5TJNd_jLLLJc4g","mobileHeaderHome":"Y43zazYy37xwc1_xwBgJw","logoHeader":"_1RmovK3IPDENghYCb3fIxo","mobileSearch":"_1fCfzxdtE5aqQM67BAAu0c","itemImage":"_3Y1C5u0UYTZRVtMNai0i2N","searchBox":"rXC72t5KaqPl8b8UmQUM9","headerTitle":"_2Cw9abRmxAauMCiPAvMEq4","searchMobile":"oOJToeWE_g6bnC41AsHri","fade":"_3MmrNMOFDI5w78nXb2RMWn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/HomeMobile.scss
// module id = 1141
// module chunks = 0